import { TypographyProps, Typography } from '@mui/joy'
import { useMemo } from 'react'
import {
  formatDateForUI,
  formatDateTimeForUI,
  formatTimeForUI,
} from '~/shared/lib/date'

type ColumnDateProps = TypographyProps & {
  type: 'dateTime' | 'date' | 'time'
  value: string | undefined | null
}

export function ColumnDate({ type, value, ...props }: ColumnDateProps) {
  const date = useMemo(() => {
    if (!value) return null

    if (type === 'date') return formatDateForUI(value)
    if (type === 'dateTime') return formatDateTimeForUI(value)
    if (type === 'time') return formatTimeForUI(value)
  }, [type, value])

  return (
    <Typography
      {...props}
      sx={{
        ...props?.sx,
        textOverflow: 'ellipsis !important',
        overflow: 'hidden !important',
        display: 'inline-block',
      }}
    >
      {date}
    </Typography>
  )
}
